module.exports = __webpack_public_path__ + "static/media/bg-vector.61298821.png";